import React from "react"
import SwiperCore, { Navigation, Pagination, A11y, Thumbs, Lazy } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import ProductItem from "./ProductItem"

SwiperCore.use([ Navigation, Pagination, A11y, Thumbs, Lazy ])

export default function RelatedProducts({
  appProps, relatedProducts
}) {

  return (
    <div className="main-container similar-products-wrapper">
      <div className="heading">
        <h2>
          { appProps.translations.products.similars_heading }
        </h2>
      </div>

      <Swiper
        effect='slide'
        navigation={ true }
        pagination={ { clickable: true } }
        spaceBetween={ 10 }
        style={{ height: '100%', width: '100%' }}
        breakpoints={{
          0: {
            slidesPerView: 1
          },
          600: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          992: {
            slidesPerView: 4
          },
          1200: {
            slidesPerView: 5
          }
        }}
        onSwiper={(swiper) => {
          const togglePagination = () => {
            const totalPages = swiper.snapGrid.length

            if (swiper.pagination.el) {
              swiper.pagination.el.style.display = totalPages <= 1 ? "none" : "block";
            }
          }

          togglePagination()
          swiper.on("resize", togglePagination)
        }}
      >
        { relatedProducts.map( (product, index) => {
            return (
              <SwiperSlide
                key={ product.id }
              >
                <ProductItem
                  appProps={ appProps }
                  key={ index }
                  product={ product }
                  showStockInfo={ false }
                  isOnSlider={ true }
                  quickViewActions={ false }
                />
              </SwiperSlide>
            )
          })
        }
      </Swiper>
    </div>
  )
}
